/**
 * Returns a function that will be executed once after the final function call within the limit
 *
 * @param {callback} func callback function to debounce
 * @param {number} limit in ms
 *
 * @return {function} Your debounced function
 */
export function debounce( func, limit ) {
    let timeout;
    return ( ...args ) => {
        clearTimeout( timeout );
        timeout = setTimeout( func, limit, ...args );
    };
}